export default "__VITE_ASSET__DUaZHp2Y__";